/**
 * @public
 */
export const buttonCellRenderer = (title, clickHandler, contentTemplate) => ({
    colId: `action-${title}`,
    width: 50,
    pinned: 'right',
    enableCellChangeFlash: false,
    cellStyle: { padding: '0', lineHeight: '25px' },
    filter: false,
    suppressFiltersToolPanel: true,
    suppressColumnsToolPanel: true,
    headerName: '',
    minWidth: 50,
    maxWidth: 50,
    resizable: false,
    cellRendererSelector: (params) => params.node.group
        ? undefined
        : {
            component: 'action',
            params: {
                actionClick: clickHandler,
                actionName: title,
                contentTemplate,
                appearance: 'neutral',
            },
        },
});
